import React, {Fragment} from 'react';
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import Button from "@mui/material/Button";
import DeleteIcon from '@mui/icons-material/Delete';

import Title from "../common/Title";


const StaffTable = ({data, removeStaff}) => {
    return (
        <Fragment>
            <Title>Staffs</Title>
            <TableContainer component={Paper} sx={{maxHeight: 450}}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Since</TableCell>
                            <TableCell>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data && data.map((doc) => (
                            <TableRow key={doc.id}>
                                <TableCell>{doc.data().name}</TableCell>
                                <TableCell>{doc.data().email}</TableCell>
                                <TableCell>{doc.data().timestamp.toDate().toLocaleString()}</TableCell>
                                <TableCell>
                                    <Button size="small"
                                            onClick={() => removeStaff(doc.data().email)}>
                                        <DeleteIcon fontSize="small"/>
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Fragment>
    );
};

export default StaffTable;